/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Openegl_Open1Inputs */

const id_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const ms_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka`)
};

const da_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åbn`)
};

const de_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen`)
};

const en_us2_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const es_es2_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const es_mx2_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const fil_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buksan`)
};

const fr_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir`)
};

const it_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri`)
};

const hu_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megnyitás`)
};

const nl_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openen`)
};

const no_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åpne`)
};

const pl_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz`)
};

const pt_br2_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const pt_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir`)
};

const ro_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deschide`)
};

const fi_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaa`)
};

const sv_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öppna`)
};

const vi_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở`)
};

const tr_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aç`)
};

const cs_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít`)
};

const bg_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отваряне`)
};

const ru_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть`)
};

const uk_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відкрити`)
};

const ar_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح`)
};

const hi_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोलें`)
};

const th_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิด`)
};

const ja_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開く`)
};

const zh_cn2_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const zh_hant1_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const ko_components_openegl_open1 = /** @type {(inputs: Components_Openegl_Open1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Components_Openegl_Open1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_openegl_open1 = /** @type {((inputs?: Components_Openegl_Open1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Openegl_Open1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_openegl_open1(inputs)
	if (locale === "ms") return ms_components_openegl_open1(inputs)
	if (locale === "da") return da_components_openegl_open1(inputs)
	if (locale === "de") return de_components_openegl_open1(inputs)
	if (locale === "en-US") return en_us2_components_openegl_open1(inputs)
	if (locale === "es-ES") return es_es2_components_openegl_open1(inputs)
	if (locale === "es-MX") return es_mx2_components_openegl_open1(inputs)
	if (locale === "fil") return fil_components_openegl_open1(inputs)
	if (locale === "fr") return fr_components_openegl_open1(inputs)
	if (locale === "it") return it_components_openegl_open1(inputs)
	if (locale === "hu") return hu_components_openegl_open1(inputs)
	if (locale === "nl") return nl_components_openegl_open1(inputs)
	if (locale === "no") return no_components_openegl_open1(inputs)
	if (locale === "pl") return pl_components_openegl_open1(inputs)
	if (locale === "pt-BR") return pt_br2_components_openegl_open1(inputs)
	if (locale === "pt") return pt_components_openegl_open1(inputs)
	if (locale === "ro") return ro_components_openegl_open1(inputs)
	if (locale === "fi") return fi_components_openegl_open1(inputs)
	if (locale === "sv") return sv_components_openegl_open1(inputs)
	if (locale === "vi") return vi_components_openegl_open1(inputs)
	if (locale === "tr") return tr_components_openegl_open1(inputs)
	if (locale === "cs") return cs_components_openegl_open1(inputs)
	if (locale === "bg") return bg_components_openegl_open1(inputs)
	if (locale === "ru") return ru_components_openegl_open1(inputs)
	if (locale === "uk") return uk_components_openegl_open1(inputs)
	if (locale === "ar") return ar_components_openegl_open1(inputs)
	if (locale === "hi") return hi_components_openegl_open1(inputs)
	if (locale === "th") return th_components_openegl_open1(inputs)
	if (locale === "ja") return ja_components_openegl_open1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_openegl_open1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_openegl_open1(inputs)
	return ko_components_openegl_open1(inputs)
});
export { components_openegl_open1 as "components.openEgl.open" }